export default "__VITE_ASSET__DlXgo574__"